<template>
  <div class="login">
    <div class="login_box">
      <div class="log teacher" @click="goStudentInfor" @mouseover="stuMouseover" @mouseout="stuMouseout">
        <img :src="studentInforIcon" alt=""/>
        <span>学生信息查询系统入口</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      studentInforIcon:require('./image/search.png')
    };
  },
  created() {
    
  },
  methods: {
    goStudentInfor(){
      window.open('http://202.115.44.69:84/');
    },
    stuMouseover(){
      this.studentInforIcon=require('./image/search02.png');
    },
    stuMouseout(){
      this.studentInforIcon=require('./image/search.png');
    }
  }
};
</script> 

<style scoped lang="scss">
.login {
  width: 100%;
  height: 60px;
  background-color: #dedede;
  .login_box {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    & > div {
      float: right;
      line-height: 60px;
      font-size: 20px;
      color: #ba2c14;
      font-weight: 600;
    }
    .log:hover{
      color: #e1270f;
    }
    .log img {
      vertical-align: middle;
      padding-right: 8px;
      padding-bottom: 4px;
    }
    .log{
      cursor: pointer;
    }
  }
}
</style>
